exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\nmat-form-field {\r\n    padding-top: 11px;\r\n    width: 49%;\r\n}\r\n\r\n.action-buttons-edit {\r\n    padding-left: 230px;\r\n}\r\n\r\n.mat-dialog-content {\r\n    height: 272px !important;\r\n}\r\n\r\n.mat-checkbox-ripple {\r\n    background-color: #4c2b5e;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/property-type-edit/property-type-edit.component.css
// module id = ../../../../../src/app/collateralskillsets/property-type-edit/property-type-edit.component.css
// module chunks = main